import React, {useCallback} from "react";
import {getFilledFieldsObjOnFormSubmit, isErrorResponse, safelyParseJson} from "../../../../utils/utils";
import {useTranslation} from "react-i18next";
import {useCloneTransitEntities} from "../../../../hooks/transitlLines/useCloneTransitEntities";
import {LoadingBackdrop} from "../../../../components/LoadingBackdrop/LoadingBackdrop";
import {Form, Row} from "../../../../components/form/Form/Form";
import * as SelectBox from "../../../../components/form/SelectBox/SelectBox";
import {useToastContext} from "../../../../context/toastContext";
import {usePresetsContext} from "../../../../context/presetsContext";
import {ActionDialogProps, ActionMenuProps} from "../../../../components/ActionMenu/ActionMenu";


const CopyLineActionFabric = ({id, loadEntitiesFn}: ActionMenuProps) => {
    const CopyLineAction: React.FC<ActionDialogProps> = ({
                                                             handleCloseDialog,
                                                         }: ActionDialogProps) => {
        const {selectedPresetId, presets} = usePresetsContext();
        const {loading, cloneLineToPreset} = useCloneTransitEntities();
        const {addToast} = useToastContext();
        const {t} = useTranslation();

        const presetsOptions = presets.map(({id, title}) => ({
            caption: title,
            value: id
        }))

        const onFormSubmit = useCallback(async (event) => {
            const formDataObj = getFilledFieldsObjOnFormSubmit(event);
            const {presetId} = formDataObj;

            const resp = await cloneLineToPreset({lineId: id, presetId: presetId?.toString() ?? ''});
            if (isErrorResponse(resp)) {
                const error = typeof resp.error === 'string' ? safelyParseJson(resp.error) : resp.error;
                addToast(`${error?.['details'] ?? t('common.save-error')}`, 'error');
            } else {
                await loadEntitiesFn();
                addToast(`${t('common.save-successful')}`, 'success');
            }
            handleCloseDialog?.(event);
        }, [id, selectedPresetId, cloneLineToPreset, handleCloseDialog]);

        return (
            <LoadingBackdrop isVisible={loading}>
                <Form
                    name="copyLineToPresetForm"
                    onSubmit={onFormSubmit}
                    submitBtnTitle={t('common.confirm')}
                    // disabled={!selectedPresetId}
                >
                    <Row>
                        <SelectBox.Labeled
                            label={t('transit-lines.copy-line-to-preset-select')}
                            name='presetId'
                            options={presetsOptions}
                            value={selectedPresetId}
                        />
                    </Row>
                </Form>
            </LoadingBackdrop>
        )
    }

    return CopyLineAction
}

export default CopyLineActionFabric;